import { isDefined, type TeamId } from '@terros/common'

export type NodeSelectAction = 'focus' | 'open' | 'close'

type NodeSelectInput = {
  teamId: TeamId
  focusTeamId: TeamId | null
  panelTeamId: TeamId | null
}

export const toNodeSelectAction = ({ teamId, focusTeamId, panelTeamId }: NodeSelectInput): NodeSelectAction => {
  if (panelTeamId === teamId) return 'close'
  if (isDefined(panelTeamId) || focusTeamId === teamId) return 'open'
  return 'focus'
}
